import type { TCounterInputProps } from "@/ui/components/form/CounterInput";
import type { TArticleProps } from "@/ui/components/layout/Article";
import type { TImageProps } from "@/ui/components/primitives/Image";
import type { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const FRESH_PRODUCT_CARD_CLASS =
  "flex w-full overflow-hidden rounded-sys-sm border border-solid border-strong bg-surface-default shadow-md";

export const FRESH_PRODUCT_CARD_IMAGE_CLASS =
  "relative w-[36%] shrink-0 self-stretch";

export const FRESH_PRODUCT_CARD_CONTENT_CLASS =
  "min-w-0 flex-1 border-l border-solid border-strong bg-surface-subtle py-2";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TFreshProductCardProps = {
  title: string;
  body: string;
  image: TImageProps;
  counterInput: TCounterInputProps;
} & Omit<TArticleProps, "children" | "onChange">;

type TFreshProductCardDefaultProps = DefinedDefaults<
  TFreshProductCardProps,
  "data-component"
>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const FRESH_PRODUCT_CARD_DEFAULTS = {
  "data-component": "FreshProductCard",
} satisfies TFreshProductCardDefaultProps;
